@if (state() === 'rendered') {
<div class="mermaid-diagram" [innerHTML]="svg()"></div>
} @else if (state() === 'failed') {
<div class="mermaid-error">
    <p class="mermaid-error__note">This diagram couldn't be displayed.</p>
    <details class="mermaid-error__details">
        <summary>View diagram source</summary>
        <pre><code>{{ code }}</code></pre>
    </details>
</div>
} @else {
<div class="mermaid-loading" role="status" aria-label="Rendering diagram">
    <span class="mermaid-loading__spinner"></span>
    <span>Rendering diagram…</span>
</div>
}
